import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Address, AddressService, MemberDetails, MemberService, PurchaseService } from '@fgb/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';

@Component({
  selector: 'fgbcl-collect-address-modal',
  templateUrl: './collect-address-modal.component.html',
  styleUrls: ['./collect-address-modal.component.scss'],
})
export class CollectAddressModal implements OnInit {
  @Input() address: Address;
  @Input() orderId: string;
  @Input() saveMemberDetailsAddress: boolean = false;
  @Input() saveOrderAddress: boolean = false;
  @Input() saveShippingAddress: boolean = false;
  @Output() submittedAddress = new EventEmitter<boolean>();

  addressForm: UntypedFormGroup;
  hasSubmitted: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private purchaseService: PurchaseService,
    private addressService: AddressService,
    private memberService: MemberService
  ) {}

  ngOnInit() {
    this.addressForm = this.formBuilder.group({
      EmailAddress: [this.address?.EmailAddress, Validators.email],
      HomeNumber: [this.address?.HomeNumber, Validators.required],
      Street: [this.address?.Street, Validators.required],
      Town: [this.address?.Town, Validators.required],
      County: [this.address?.County, Validators.required],
      Country: [this.address?.Country, Validators.required],
      Postcode: [this.address?.Postcode, [Validators.required, Validators.pattern(RegexUS.postCode)]],
      FirstName: [this.address?.FirstName, Validators.required],
      Surname: [this.address?.Surname, Validators.required],
      PortalId: [this.address?.PortalId],
      ClubId: [this.address?.ClubId],
    });
  }

  closeModal(): void {
    this.activeModal.close();
  }

  saveAddress() {
    this.hasSubmitted = true;
    this.address = { ...this.address, ...this.addressForm.value };

    if (this.addressForm.invalid) {
      return;
    }

    if (this.saveOrderAddress) {
      this.purchaseService
        .updatePurchaseAddress(this.orderId, this.address)
        .toPromise()
        .then(() => {
          this.submittedAddress.emit(true);
        });
    } else if (this.saveMemberDetailsAddress) {
      let memberDetails = {
        PortalId: this.address.PortalId,
        EmailAddress1: this.address.EmailAddress,
        AddressName: this.address.AddressName,
        Street: this.address.Street,
        Town: this.address.Town,
        Country: this.address.Country,
        HomeNumber: this.address.HomeNumber,
        County: this.address.County,
        PostCode: this.address.Postcode,
        FirstName: this.address.FirstName,
        Surname: this.address.Surname,
        ClubId: this.address.ClubId,
      } as MemberDetails;

      this.memberService
        .updateMemberDetailsAsync(this.address.PortalId, memberDetails)
        .toPromise()
        .then(() => {
          this.submittedAddress.emit(true);
        });
    } else if (this.saveShippingAddress) {
      this.addressService.saveAddress(this.address).then(() => {
        this.submittedAddress.emit(true);
      });
    }
  }
}
